import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const confirmInvitationLink = async (invitationLink) => {
    return axios.get(`${BACKEND_URL}/invitationLink/confirm/${invitationLink}`);
};

export const sendInvitationLink = async (email) => {
    return axios.post(`${BACKEND_URL}/invitationLink/${email}`);
};